import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ScheduleDisplay = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 10000);
    return () => clearInterval(interval);
  }, []);

  const fetchData = async () => {
    try {
      const roomsResponse = await axios.get(`${API}/rooms`);
      const rooms = roomsResponse.data;

      const today = new Date().toISOString().split('T')[0];
      const allEventsPromises = rooms.map(room =>
        axios.get(`${API}/events/room/${room.id}/today`)
      );

      const eventsResponses = await Promise.all(allEventsPromises);

      let allEvents = [];
      eventsResponses.forEach((response, index) => {
        const roomEvents = response.data.map(event => ({
          ...event,
          roomName: rooms[index].name
        }));
        allEvents = [...allEvents, ...roomEvents];
      });

      allEvents.sort((a, b) => a.start_time.localeCompare(b.start_time));

      const now = new Date();
      const currentTimeStr = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
      const futureEvents = allEvents.filter(event => event.end_time > currentTimeStr);

      setEvents(futureEvents.slice(0, 6));
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };

  const formatTime = (timeStr) => {
    return timeStr.substring(0, 5);
  };

  const formatDate = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const isEventActive = (event) => {
    const now = new Date();
    const currentTimeStr = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    return currentTimeStr >= event.start_time && currentTimeStr < event.end_time;
  };

  const hasActiveEvent = events.length > 0;

  return (

    <div className="min-h-screen flex flex-col p-12"
      style={{
        background: 'linear-gradient(180deg, #f5f3ff 0%, #faf5ff 100%)'
      }}
      data-testid="schedule-display">

      {!hasActiveEvent && (
        <div className="absolute inset-0 w-full h-full bg-gradient-to-b from-[#f5f3ff] to-[#faf5ff] flex items-center justify-center">
          <div className="text-center">
            <div className="text-center">
              <div className="flex justify-center mb-12">
                <img src="/balloons.svg" alt="Balon" width={500} height={150} />
              </div>

              <h2 className="text-4xl font-bold mb-6"
                style={{ fontFamily: 'Momo Trust Display, sans-serif', color: '#6E35C0' }}>
                ZORGANIZUJ NIEZAPOMNIANE<br />URODZINY W AVEPARK!
              </h2>

              <div className="inline-block bg-purple-600 text-white px-16 py-6 rounded-full shadow-xl"
                style={{ backgroundColor: '#6E35C0' }}>
                <p className="text-4xl font-bold"
                  style={{ fontFamily: 'Momo Trust Display, sans-serif' }}>
                  URODZINY.AVEPARK.PL
                </p>
              </div>
            </div>
          </div>
        </div>
      )}


      {hasActiveEvent && (
        <>
          <div className="text-center mb-4">
            <p className="text-5xl"
              style={{ fontFamily: 'Momo Trust Display, sans-serif', color: '#6E35C0' }}>
              {formatDate()}
            </p>
          </div>

          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="text-8xl font-bold leading-tight"
              style={{ fontFamily: 'Momo Trust Display, sans-serif', color: '#6E35C0' }}>
              DZISIEJSZE
            </h1>
            <h1 className="text-8xl font-bold"
              style={{ fontFamily: 'Momo Trust Display, sans-serif', color: '#6E35C0' }}>
              URODZINY
            </h1>
          </div>
        </>
      )}

      {/* Balloons SVG */}
      <div className="flex justify-center mb-12">
        <img src="/balloons.svg" alt="Balon" width={500} height={150} />
      </div>

      {/* Events List */}
      <div className="flex-1 max-w-5xl mx-auto w-full space-y-6">
        {events.length === 0 ? (
          <div className="text-center">
            {/* Balloons for empty state */}

            <h2 className="text-4xl font-bold mb-6"
              style={{ fontFamily: 'Momo Trust Display, sans-serif', color: '#6E35C0' }}>
              ZORGANIZUJ NIEZAPOMNIANE<br />URODZINY W AVEPARK!
            </h2>

            <div className="inline-block bg-purple-600 text-white px-16 py-6 rounded-full shadow-xl"
              style={{ backgroundColor: '#6E35C0' }}>
              <p className="text-4xl font-bold"
                style={{ fontFamily: 'Momo Trust Display, sans-serif' }}>
                WWW.URODZINY.AVEPARK.PL
              </p>
            </div>
          </div>
        ) : (
          events.map((event, index) => {
            const active = isEventActive(event);
            return (
              <div
                key={event.id || index}
                className="flex items-center justify-between bg-white rounded-full px-6 py-5 shadow-md border-4 transition-all"
                style={{
                  borderColor: active ? '#6E35C0' : 'transparent'
                }}
                data-testid={`schedule-event-${index}`}
              >
                {/* Time or "W TRAKCIE" */}
                <div className={`px-8 py-3 rounded-full font-bold text-2xl ${active ? 'bg-purple-600 text-white' : 'border-2 text-purple-600'
                  }`}
                  style={{
                    backgroundColor: active ? '#6E35C0' : 'transparent',
                    borderColor: active ? 'transparent' : '#6E35C0',
                    color: active ? 'white' : '#6E35C0',
                    fontFamily: 'Momo Trust Display, sans-serif',
                    minWidth: '200px',
                    textAlign: 'center'
                  }}>
                  {active ? 'W TRAKCIE' : `${formatTime(event.start_time)} - ${formatTime(event.end_time)}`}
                </div>

                {/* Name */}
                <div className="flex-1 text-center">
                  <h3 className="text-5xl font-bold uppercase"
                    style={{
                      fontFamily: 'Momo Trust Display, sans-serif',
                      color: '#6E35C0',
                      letterSpacing: '0.02em'
                    }}>
                    {event.name}
                  </h3>
                </div>

                {/* Room */}
                <div className="bg-purple-600 text-white px-8 py-3 rounded-full shadow-md font-bold text-2xl"
                  style={{
                    backgroundColor: '#6E35C0',
                    fontFamily: 'Momo Trust Display, sans-serif',
                    minWidth: '140px',
                    textAlign: 'center'
                  }}>
                  {event.roomName.toUpperCase()}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ScheduleDisplay;